import { createFileRoute } from '@tanstack/react-router';
import { LocalSettingsPage } from './LocalSettingsPage';

export const Route = createFileRoute('/_protected/admin/internal-tools/local-settings/')({
  component: LocalSettingsPage,
});
